import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Button, Table, Modal } from "react-bootstrap";
import InputField from "./InputfieldSales";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import baseURL from "../../../../Url/NodeBaseURL";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
//
const PaymentDetails = ({
  loadInvoiceData,
  setInvoiceDataLoaded,
  orderDetails,
  paymentDetails,
  setPaymentDetails,
  handleSave,
  saveLoading,
  handleBack,
  repairDetails,
  setRepairDetails,
  totalPrice,
  schemeSalesData,
  oldSalesData,
  taxableAmount,
  discountAmt,
  totalAmount,
  taxAmount,
  oldItemsAmount,
  schemeAmount,
  netPayableAmount,
  netAmount,
  salesNetAmount,
  salesTaxableAmount,
  //
  savedNetPayableAmount,
  setSavedNetPayableAmount,
  salesAmountToPass,
  updatedOldItemsAmount,
  netPayAmount,
  discount,
  handleDiscountChange,
  refreshSalesData,
  offers,
  loading,
  festivalShowModal,
  handleFestivalShowModal,
  handleFestivalCloseModal,
  appliedOffers,
  setAppliedOffers,
  festivalDiscountAmt,
  handleApply,
  isAnyOfferApplied,
  manualNetAmount,
  setManualNetAmount,
  handleManualNetAmountChange,
  isManualNetMode,
  setIsManualNetMode,
  handleManualNetPayAmountChange,
  manualNetPayAmount,
  handleManualNetPayableChange,
  applyDiscountAmountToRepairDetails,
  setRoundOffAmountForSaveRepairsApiCall,
  setIsManualNetPayableSet,
  selectedRows,
  setNetPayableEditable,
  setResetActiveForm,
  totalAdvanceAmount,
  invoice_number,
}) => {
  function isCurrentDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  const [isTodayDate, setIsTodayDate] = useState(false);
  const [isExistingSales, setIsExistingSales] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);

  useEffect(() => {
    async function isToday() {
      try {
        const response = await axios.get(
          `${baseURL}/get-repair-details/${invoice_number}`
        );

        const repeatedData = response.data?.repeatedData;
        const apiDate = repeatedData?.[0]?.date;
        console.log("API date is:", apiDate);

        if (!apiDate) {
          console.warn("Date not found in API response.");
          setIsTodayDate(false);
          setIsExistingSales(false);
          return;
        }

        const result = isCurrentDate(apiDate);
        setIsTodayDate(result);
        
        // Check if this is an existing sales (has data in database)
        setIsExistingSales(repeatedData && repeatedData.length > 0);
      } catch (error) {
        console.error("Error fetching repair details:", error);
        setIsTodayDate(true);
        setIsExistingSales(false);
      }
    }

    if (invoice_number) {
      isToday();
    }
  }, [invoice_number]);
  const [manualNetPayAmountPayment, setManualNetPayAmountPayment] = useState(0);
  const [editedManualNetPayAmountPayment, setEditedManualNetPayAmountPayment] =
    useState(0);
  const [isEdited, setIsEdited] = useState(false);
  const [isEditedNetPayableAmount, setIsEditedNetPayableAmount] =
    useState(false);

  // Set up the ref to expose setIsEditedNetPayableAmount to parent
  useEffect(() => {
    if (setNetPayableEditable) {
      setNetPayableEditable.current = () => {
        // Exit saved manual-net mode and allow recalculation on parent-triggered changes
        setIsEditedNetPayableAmount(false);
        setIsSaveNetPayableAmount(false);
        setIsManualNetPayableSet(false);
        // Clear any saved amount so it recalculates freshly from SalesForm
        setSavedNetPayableAmount(0);
      };
    }
  }, [
    setNetPayableEditable,
    setIsManualNetPayableSet,
    setSavedNetPayableAmount,
  ]);
  const [isSaveNetPayableAmount, setIsSaveNetPayableAmount] = useState(false);
  //const [savedNetPayableAmount, setSavedNetPayableAmount] = useState(0);
  const [roundOffAmount, setRoundOffAmount] = useState(0);

  // Log the received savedNetPayableAmount

  const [originalNetPayableAmount, setOriginalNetPayableAmount] = useState(0);
  const [originalNetAmount, setOriginalNetAmount] = useState(0);
  const netPayableInputRef = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    // Auto-enable editing when sales return checkboxes are selected OR URD purchase changes
    const hasSelectedRows = selectedRows && selectedRows.length > 0;
    const hasOldItems = oldItemsAmount > 0;

    if (hasSelectedRows || hasOldItems) {
      // Only make it editable if the Net Payable Amount hasn't been manually saved
      if (!isSaveNetPayableAmount) {
        setIsEditedNetPayableAmount(false);

        setIsSaveNetPayableAmount(false);
        setIsManualNetPayableSet(false);
      }
      // Keep it non-editable since it's been manually saved
    } else {
      setIsEditedNetPayableAmount(true);
    }
  }, [selectedRows, oldItemsAmount, isSaveNetPayableAmount]);
  useEffect(() => {
    // pull the latest data
    const fetchOrderDetails = async () => {
      try {
        if (location.state?.from === "orders") return;
        // Only update if the values are not empty strings or minus signs
        if (
          typeof netPayableAmount === "number" ||
          (typeof netPayableAmount === "string" &&
            netPayableAmount !== "" &&
            netPayableAmount !== "-")
        ) {
          setManualNetPayAmountPayment(netPayableAmount);
          setEditedManualNetPayAmountPayment(netPayableAmount);
        }
        if (repairDetails[0]?.order_number) {
          const response = await axios.get(
            `${baseURL}/get-order-details/${repairDetails[0].order_number}`
          );

          if (response.data) {
            // handleManualNetPayAmountChange(response.data.repeatedData[0].bal_amt);
            setManualNetPayAmountPayment(response.data.repeatedData[0].bal_amt);
            setEditedManualNetPayAmountPayment(
              response.data.repeatedData[0].bal_amt
            );
          }
        }
      } catch (error) {
        // Error fetching order details
      }
    };

    fetchOrderDetails();
  }, [repairDetails]);

  useEffect(() => {
    // Only update if the values are not empty strings or minus signs
    // AND if the Net Payable Amount hasn't been manually saved
    if (
      (typeof netPayableAmount === "number" ||
        (typeof netPayableAmount === "string" &&
          netPayableAmount !== "" &&
          netPayableAmount !== "-")) &&
      !isSaveNetPayableAmount
    ) {
      setManualNetPayAmountPayment(netPayableAmount);
      setEditedManualNetPayAmountPayment(netPayableAmount);
    }

    // Reset original values when starting fresh (no old items, no sales return)
    const isNewProduct =
      oldItemsAmount === 0 && (!selectedRows || selectedRows.length === 0);

    if (isNewProduct) {
      setOriginalNetPayableAmount(netPayableAmount);
      setOriginalNetAmount(netAmount);
    } else {
      // Store the original net payable amount when first loaded (before any manual changes)
      if (originalNetPayableAmount === 0) {
        setOriginalNetPayableAmount(netPayableAmount);
      }
      // Store the original net amount when first loaded (before any discounts)
      if (originalNetAmount === 0) {
        setOriginalNetAmount(netAmount);
      }
    }
  }, [
    netPayableAmount,
    netAmount,
    originalNetPayableAmount,
    originalNetAmount,
    oldItemsAmount,
    selectedRows,
    isSaveNetPayableAmount,
  ]);

  // Update payment details when net payable amount changes (for any reason)
  useEffect(() => {
     if (loadInvoiceData) return;
    // Only update payment details if net payable amount has changed and it hasn't been manually saved
    if (
      !isSaveNetPayableAmount &&
      typeof netPayableAmount === "number" &&
      netPayableAmount > 0
    ) {
      const updatedNetPayable = Math.round(netPayableAmount);

      // Check if the current online amount is different from the new net payable amount
      const currentOnlineAmount = parseFloat(paymentDetails.online_amt || 0);

      if (currentOnlineAmount !== updatedNetPayable) {
        // Update payment details to set online amount to match net payable
        // and reset other payment methods to 0
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [netPayableAmount, isSaveNetPayableAmount]);

  // Update net payable amount when sales return items are selected/deselected
  useEffect(() => {
     if (loadInvoiceData) return;
    if (selectedRows && selectedRows.length > 0) {
      // When sales return items are selected, update the net payable amount
      // This should work even after manual save to reflect sales return deductions
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);
      // Also update savedNetPayableAmount so it's reflected in the display after manual save
      setSavedNetPayableAmount(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [selectedRows, netPayableAmount, manualNetPayAmountPayment, loadInvoiceData, setSavedNetPayableAmount]);

  // Update net payable amount when URD purchase changes (oldItemsAmount changes)
  useEffect(() => {
    if (loadInvoiceData) return;
    if (oldItemsAmount > 0) {
      // When URD purchase data changes, update the net payable amount
      // This should work even after manual save to reflect URD purchase deductions
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);
      // Also update savedNetPayableAmount so it's reflected in the display after manual save
      setSavedNetPayableAmount(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [oldItemsAmount, netPayableAmount, manualNetPayAmountPayment, loadInvoiceData, setSavedNetPayableAmount]);

  //Update net payable amount when sales return changes (salesAmountToPass changes)
  useEffect(() => {
    if (loadInvoiceData) return;
    if (salesAmountToPass > 0) {
      // When sales return data changes, update the net payable amount
      // This should work even after manual save to reflect sales return deductions
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);
      // Also update savedNetPayableAmount so it's reflected in the display after manual save
      setSavedNetPayableAmount(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [salesAmountToPass, netPayableAmount, manualNetPayAmountPayment, loadInvoiceData, setSavedNetPayableAmount]);

  // Reset all payment fields to 0 when net payable amount becomes negative
  // BUT only if it's not a credit situation (when user has manually set payment details)
  useEffect(() => {
    const currentNetPayable = isSaveNetPayableAmount
      ? Math.round(savedNetPayableAmount)
      : Math.round(manualNetPayAmountPayment);

    if (currentNetPayable < 0) {
      // Check if user has manually entered any payment details
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0 ||
        parseFloat(paymentDetails.online_amt || 0) !== 0;

      if (!hasManualPayments) {
        const resetPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: 0,
        };

        setPaymentDetails(resetPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(resetPaymentDetails)
        );
      }
    }
  }, [
    isSaveNetPayableAmount,
    savedNetPayableAmount,
    manualNetPayAmountPayment,
    paymentDetails,
  ]);

  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [appliedOfferKey, setAppliedOfferKey] = useState(null);
  //const [oldItemsSalesAmount, setOldItemsSalesAmount] = useState(0);
  const navigate = useNavigate();
  // In your component state

  let rounded = Math.round(
    isSaveNetPayableAmount
      ? savedNetPayableAmount
      : Math.round(manualNetPayAmountPayment)
  );
  // call api to get old items amount
  /* useEffect(() => {
    const fetchOldItems = async () => {
      if (repairDetails[0]?.order_number) {
        const response = await axios.get(
          `${baseURL}/get/olditems/${repairDetails[0].order_number}`
        );
        setOldItemsSalesAmount(
          response.data.reduce(
            (sum, item) => sum + parseFloat(item.total_amount || 0),
            0
          )
        );
      }
    };
    fetchOldItems();
  }, [orderDetails]); */

  const handleNew = () => {
    setIsSaveNetPayableAmount(false);
    setIsEditedNetPayableAmount(false);
    setIsEdited(false);
    setRoundOffAmount(0);
    setSavedNetPayableAmount(0);
    setIsManualNetPayableSet(false); // Reset the manual flag
    setOriginalNetPayableAmount(0); // Reset original amount
    setOriginalNetAmount(0); // Reset original net amount
    setEditedManualNetPayAmountPayment(0);
    setManualNetPayAmountPayment(0);

    // Clear localStorage data
    localStorage.clear();
    
    // Trigger reset of active form
    if (setResetActiveForm) {
      setResetActiveForm(true);
    }

    const timestamp = Date.now();

    // 🔁 Open Sales tab in a new tab
    const url = `/sales?reset=true&t=${timestamp}&isEstimatePage=false`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const storedPaymentDetails =
      JSON.parse(localStorage.getItem(`paymentDetails`)) || {};

    const cashAmount =
      location.state?.cash_amount ??
      storedPaymentDetails.cash_amount ??
      rounded;

    const cardAmt =
      location.state?.card_amt ?? storedPaymentDetails.card_amt ?? 0;

    const chqAmt = location.state?.chq_amt ?? storedPaymentDetails.chq_amt ?? 0;

    const onlineAmt =
      location.state?.online_amt ?? storedPaymentDetails.online_amt ?? 0;

    const newPaymentDetails = {
      cash_amount: cashAmount,
      card_amt: cardAmt,
      chq_amt: chqAmt,
      online_amt: onlineAmt,
    };

    setPaymentDetails(newPaymentDetails);
  }, [location.state]); // Removed isSaveNetPayableAmount from dependencies

  useEffect(() => {
    // Only update if cash_amount is NOT provided from location.state
    if (rounded && location.state?.cash_amount === undefined) {
      setPaymentDetails((prev) => {
        const updatedDetails = {
          ...prev,
          online_amt: Math.round(rounded), // Ensure it's rounded to avoid decimal precision issues
        };
        localStorage.setItem(`paymentDetails`, JSON.stringify(updatedDetails));
        return updatedDetails;
      });
    }
  }, [rounded, location.state]);

  useEffect(() => {
    // Sum of all payment details
    const totalEnteredAmount =
      parseFloat(paymentDetails.cash_amount || 0) +
      parseFloat(paymentDetails.card_amt || 0) +
      parseFloat(paymentDetails.chq_amt || 0) +
      parseFloat(paymentDetails.online_amt || 0);

    const tolerance = 0.01; // Small tolerance for floating point precision issues

    setIsSubmitEnabled(
      Math.abs(totalEnteredAmount - parseFloat(totalPrice || 0)) < tolerance
    );
  }, [paymentDetails, totalPrice]);

  const handlePaymentChange = (field, value) => {
    // Get the current net payable amount
    const currentNetPayable = isSaveNetPayableAmount
      ? Math.round(savedNetPayableAmount)
      : Math.round(manualNetPayAmountPayment);

    // Handle empty or invalid inputs
    if (
      value === "" ||
      value === null ||
      value === "-" ||
      value === "-0" ||
      value === "-0." ||
      value === "-0.0" ||
      value === "-0.00"
    ) {
      const updatedDetails = {
        ...paymentDetails,
        [field]: value,
      };
      setPaymentDetails(updatedDetails);
      localStorage.setItem(`paymentDetails`, JSON.stringify(updatedDetails));
      return;
    }

    // Parse the new value
    let newValue = parseFloat(value);
    if (isNaN(newValue)) {
      newValue = 0;
    }

    // Get current payment details
    const currentCash = parseFloat(paymentDetails.cash_amount || 0);
    const currentCard = parseFloat(paymentDetails.card_amt || 0);
    const currentCheque = parseFloat(paymentDetails.chq_amt || 0);
    const currentOnline = parseFloat(paymentDetails.online_amt || 0);

    let updatedDetails = { ...paymentDetails };

    if (field === "online_amt") {
      // User is directly editing online amount
      updatedDetails = {
        ...paymentDetails,
        online_amt: Math.round(newValue),
      };
    } else {
      // User is editing cash, card, or cheque amount
      // Calculate the new online amount to keep total equal to net payable
      const otherPayments =
        (field === "cash_amount" ? newValue : currentCash) +
        (field === "card_amt" ? newValue : currentCard) +
        (field === "chq_amt" ? newValue : currentCheque);

      const newOnlineAmount = Math.max(0, currentNetPayable - otherPayments);

      updatedDetails = {
        ...paymentDetails,
        [field]: newValue,
        online_amt: Math.round(newOnlineAmount),
      };
    }

    // Calculate total payment amount
    const totalPaymentAmount =
      parseFloat(updatedDetails.cash_amount || 0) +
      parseFloat(updatedDetails.card_amt || 0) +
      parseFloat(updatedDetails.chq_amt || 0) +
      parseFloat(updatedDetails.online_amt || 0);

    // Validate total payment doesn't exceed net payable (for positive net payable)
    if (currentNetPayable >= 0 && totalPaymentAmount > currentNetPayable) {
      alert("Total payment amount cannot exceed Net Payable Amount.");
      return;
    }

    // Update state and storage
    setPaymentDetails(updatedDetails);
    localStorage.setItem(`paymentDetails`, JSON.stringify(updatedDetails));
  };

  const handleClose = () => {
    // navigate(`/sales?tabId=${tabId}`);
    navigate(-1);
  };

  const handleSaveNetPayableAmount = () => {
    // Get the current value from the appropriate state
    const currentValue = isSaveNetPayableAmount
      ? savedNetPayableAmount
      : editedManualNetPayAmountPayment;
    const newNetPayableAmount = parseFloat(currentValue);

    // Validate that net payable doesn't exceed the expected net payable
    // Use the same calculation as in SalesForm for consistency
    const totalDeductions =
      oldItemsAmount + salesAmountToPass + schemeAmount + totalAdvanceAmount;
    const expectedNetPayable = netAmount - totalDeductions;

    // Always use the calculated expectedNetPayable for validation
    const maxAllowedAmount = expectedNetPayable;

    const tolerance = 1; // allow rounding difference
    if (newNetPayableAmount - maxAllowedAmount > tolerance) {
      // Debug logging with breakdown
      // eslint-disable-next-line no-console
      console.debug(
        "[PaymentDetails.handleSaveNetPayableAmount] Validation failed",
        {
          enteredNetPayable: newNetPayableAmount,
          maxAllowedAmount,
          netAmount,
          deductions: {
            oldItemsAmount,
            schemeAmount,
            salesAmountToPass,
            totalAdvanceAmount,
          },
        }
      );

      alert(
        `Net Payable (${newNetPayableAmount}) cannot exceed calculated (${maxAllowedAmount}).\n` +
          `netAmount=${netAmount}, deductions: oldItems=${oldItemsAmount}, scheme=${schemeAmount}, salesReturn=${salesAmountToPass}, advance=${totalAdvanceAmount}`
      );

      // Reset the input field to the previous valid value
      const previousValidAmount = isSaveNetPayableAmount
        ? savedNetPayableAmount
        : manualNetPayAmountPayment;
      setEditedManualNetPayAmountPayment(previousValidAmount);
      setManualNetPayAmountPayment(previousValidAmount);

      // Keep the mode as editable so user can try again
      setIsEditedNetPayableAmount(false);
      setIsSaveNetPayableAmount(false);

      return;
    }

    // Use the new function from SalesForm to handle the reverse calculation
    let validationSuccess = true;
    if (handleManualNetPayableChange) {
      validationSuccess = handleManualNetPayableChange(newNetPayableAmount);
    }

    // Only proceed with updates if validation was successful
    if (validationSuccess) {
      // Update local state
      setEditedManualNetPayAmountPayment(newNetPayableAmount);
      setManualNetPayAmountPayment(newNetPayableAmount);
      setIsEditedNetPayableAmount(true);
      setIsSaveNetPayableAmount(true);
      setSavedNetPayableAmount(newNetPayableAmount);
      setIsManualNetPayableSet(true); // Mark as manually set to prevent auto-updates
    } else {
      // Validation failed, reset to previous values and keep editable
      const previousValidAmount = isSaveNetPayableAmount
        ? savedNetPayableAmount
        : manualNetPayAmountPayment;
      setEditedManualNetPayAmountPayment(previousValidAmount);
      setManualNetPayAmountPayment(previousValidAmount);
      setIsEditedNetPayableAmount(false);
      setIsSaveNetPayableAmount(false);
      return;
    }

    // Update payment details based on Net Payable Amount
    let updatedPaymentDetails;

    // For positive Net Payable Amount, reset all payment methods to 0 except online
    // and set online amount to match Net Payable Amount
    updatedPaymentDetails = {
      cash_amount: 0,
      card_amt: 0,
      chq_amt: 0,
      online_amt: Math.round(newNetPayableAmount),
    };

    // Update payment details directly
    setPaymentDetails(updatedPaymentDetails);
    localStorage.setItem(
      `paymentDetails`,
      JSON.stringify(updatedPaymentDetails)
    );
  };

  const handleEdit = (amount) => {
    if (isEditedNetPayableAmount) {
      setIsEditedNetPayableAmount(false);
    } else {
      setIsEditedNetPayableAmount(true);
    }
  };
  // Example useEffect to handle logic after state update
  useEffect(() => {
    // Perform any additional logic needed after the state update
  }, [manualNetPayAmountPayment]);

  // Focus the input when it is rendered and not in edit mode
  /* useEffect(() => {
    if (!isEditedNetPayableAmount && netPayableInputRef.current) {
      netPayableInputRef.current.focus();
    }
  }, [isEditedNetPayableAmount]); */

  const balanceAmount = Math.round(
    (isSaveNetPayableAmount
      ? savedNetPayableAmount
      : manualNetPayAmountPayment) -
      (parseFloat(paymentDetails.cash_amount || 0) +
        parseFloat(paymentDetails.card_amt || 0) +
        parseFloat(paymentDetails.chq_amt || 0) +
        parseFloat(paymentDetails.online_amt || 0))
  );

  return (
    <>
      <div>
        <Col className="sales-form-section">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "20px" }}>
              Summary
            </h4>
            {/* <div style={{ maxHeight: "140px", overflowY: "auto" }}> */}
            <Table bordered hover responsive>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Total Amount
                </td>
                <td colSpan="4">{totalAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="12" className="text-right">
                  Discount Amount
                </td>
                <td colSpan="4">
                  @ {discount == 0 ? "" : discount.toFixed(2)} %
                  {/* <input
                    type="number"
                    value={discount ? discount.toFixed(2) : 0}
                    readOnly
                    style={{
                      width: "70px",
                      padding: "2px",
                      fontSize: "13px",
                    }}
                  /> */}
                </td>

                <td colSpan="4">{Math.max(discountAmt, 0).toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="12" className="text-right">
                  Festival Offer
                </td>
                <td colSpan="4"> &ensp;&ensp;</td>

                <td colSpan="4">
                  {festivalDiscountAmt.toFixed(2)}
                  <Button
                    onClick={handleFestivalShowModal}
                    style={{
                      display: "none",
                      backgroundColor: "#a36e29",
                      borderColor: "#a36e29",
                      fontSize: "12px",
                      padding: "2px 8px",
                      marginLeft: "10px",
                    }}
                    size="sm"
                  >
                    Apply Offer
                  </Button>
                </td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Taxable Amount
                </td>
                <td colSpan="4">{taxableAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Tax Amount
                </td>
                <td colSpan="4">{taxAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Net Amount
                </td>
                <td colSpan="4">{netAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Old Items Amount
                </td>
                {/* <td colSpan="4">{oldItemsSalesAmount.toFixed(2)}</td> */}
                <td colSpan="4">{Number(oldItemsAmount || 0).toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Scheme Amount
                </td>
                <td colSpan="4">{Number(schemeAmount || 0).toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Sale Return Amount
                </td>
                {/* <td colSpan="4">{salesNetAmount.toFixed(2)}</td> */}
                <td colSpan="4">{Number(salesAmountToPass || 0).toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }} className="d-none">
                <td colSpan="16" className="text-right">
                  Round Off
                </td>
                {/* <td colSpan="4">{salesNetAmount.toFixed(2)}</td> */}
                <td colSpan="4">{roundOffAmount.toFixed(2)}</td>
              </tr>

              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Net Payable Amount
                </td>
                {isEditedNetPayableAmount && isTodayDate ? (
                  <td colSpan="4">
                    {isSaveNetPayableAmount
                      ? Math.round(savedNetPayableAmount).toFixed(2)
                      : Math.round(netPayableAmount).toFixed(2)}

                    {isTodayDate && (
                      <FontAwesomeIcon
                        icon={faPencil}
                        onClick={() => handleEdit()}
                        style={{
                          cursor: "pointer",
                          color: "black",
                          backgroundColor: "transparent",
                          marginLeft: "8px",
                        }}
                      />
                    )}
                  </td>
                ) : (
                  <td colSpan="4">
                    {isTodayDate ? (<input
                      ref={netPayableInputRef}
                      type="number"
                      style={{
                        width: "100px",
                        padding: "5px",
                        fontSize: "13px",
                      }}
                      value={
                        isSaveNetPayableAmount
                          ? savedNetPayableAmount === "" ||
                            savedNetPayableAmount === "-"
                            ? savedNetPayableAmount
                            : Math.round(savedNetPayableAmount)
                          : editedManualNetPayAmountPayment === "" ||
                            editedManualNetPayAmountPayment === "-"
                          ? editedManualNetPayAmountPayment
                          : Math.round(editedManualNetPayAmountPayment)
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        // Allow empty input for backspace/clearing
                        if (inputValue === "" || inputValue === null) {
                          if (isSaveNetPayableAmount) {
                            setSavedNetPayableAmount("");
                            setEditedManualNetPayAmountPayment("");
                          } else {
                            setEditedManualNetPayAmountPayment("");
                          }
                          return;
                        }

                        // Allow minus sign for negative numbers
                        if (inputValue === "-") {
                          if (isSaveNetPayableAmount) {
                            setSavedNetPayableAmount("-");
                            setEditedManualNetPayAmountPayment("-");
                          } else {
                            setEditedManualNetPayAmountPayment("-");
                          }
                          return;
                        }

                        // For any other input, try to parse as number
                        const newValue = parseFloat(inputValue);

                        // Check if it's a valid number (including negative numbers)
                        if (isNaN(newValue)) {
                          return; // Don't update if it's not a valid number
                        }

                        // Round the value
                        const roundedValue = Math.round(newValue);

                        if (isSaveNetPayableAmount) {
                          setSavedNetPayableAmount(roundedValue);
                          setEditedManualNetPayAmountPayment(roundedValue);
                        } else {
                          setEditedManualNetPayAmountPayment(roundedValue);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleSaveNetPayableAmount();
                        }
                      }}
                    />):isSaveNetPayableAmount
                    ? savedNetPayableAmount === "" ||
                      savedNetPayableAmount === "-"
                      ? savedNetPayableAmount
                      : Math.round(savedNetPayableAmount)
                    : editedManualNetPayAmountPayment === "" ||
                      editedManualNetPayAmountPayment === "-"
                    ? editedManualNetPayAmountPayment
                    : Math.round(editedManualNetPayAmountPayment)}
                    {isTodayDate && (
                      <Link onClick={() => handleSaveNetPayableAmount()}>
                        Save
                      </Link>
                    )}
                  </td>
                )}
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">
                  Balance Amount
                </td>
                <td colSpan="4">{balanceAmount.toFixed(2)}</td>
              </tr>
            </Table>
            {/* </div> */}
          </Row>
        </Col>

        <Col className="sales-form-section">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "18px" }}>
              Payment Details
            </h4>
            <Col xs={12} md={4}>
              <InputField
                label="Online Amt"
                name="online_amt"
                type="number"
                value={paymentDetails.online_amt}
                onChange={(e) =>
                  handlePaymentChange("online_amt", e.target.value)
                }
                readOnly={!isTodayDate}
                disabled={!isTodayDate}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Card Amt"
                name="card_amt"
                type="number"
                value={paymentDetails.card_amt || ""}
                onChange={(e) =>
                  handlePaymentChange("card_amt", e.target.value)
                }
                readOnly={!isTodayDate}
                disabled={!isTodayDate}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Cheque Amt"
                name="chq_amt"
                type="number"
                value={paymentDetails.chq_amt || ""}
                onChange={(e) => handlePaymentChange("chq_amt", e.target.value)}
                readOnly={!isTodayDate}
                disabled={!isTodayDate}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Cash Amt"
                name="cash_amount"
                type="number"
                value={paymentDetails.cash_amount || ""}
                onChange={(e) =>
                  handlePaymentChange("cash_amount", e.target.value)
                }
                readOnly={!isTodayDate}
                disabled={!isTodayDate}
              />
            </Col>
            <Col xs={12} md={3}>
              {isTodayDate && (<Button
                onClick={async () => {
                  if (!isEditedNetPayableAmount) return;

                  setSaveLoader(true); 
                  try {
                    await handleSave();
                  } finally {
                    setSaveLoader(false); 
                  }
                }}
                disabled={saveLoader}

                style={{
                  backgroundColor: isEditedNetPayableAmount
                    ? "#a36e29"
                    : "gray",
                  borderColor: isEditedNetPayableAmount ? "#a36e29" : "gray",
                  fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px",
                }}
              >
                {saveLoader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving
                  </>
                ) : (
                  isExistingSales ? "Update" : "Save"
                )}
              </Button>)}
            </Col>

            <Col xs={12} md={1}>
              <Button
                onClick={handleClose}
                style={{
                  backgroundColor: "gray",
                  borderColor: "gray",
                  marginLeft: "-57px",
                  marginTop: "3px",
                  padding: "4px 10px",
                  fontSize: "14px",
                }}
                // disabled={!isSubmitEnabled}
              >
                Close
              </Button>
            </Col>
            <Col xs={12} md={2}>
              <Button
                onClick={handleNew}
                style={{
                  backgroundColor: "gray",
                  borderColor: "gray",
                  marginLeft: "-30px",
                  fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px",
                }}
              >
                New
              </Button>
            </Col>
          </Row>
        </Col>
      </div>

      <Modal
        show={festivalShowModal}
        onHide={handleFestivalCloseModal}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Available Offers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading offers...</p>
          ) : offers.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S No</th>
                  <th>Offer Name</th>
                  <th>Discount On Rate</th>
                  <th>Discount % on MC</th>
                  <th>Discount % for Fixed</th>
                  <th>Valid From</th>
                  <th>Valid To</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offers.map((offer, index) => {
                  const offerKey = `${offer._id}_${index}`;
                  const isApplied = appliedOffers[offerKey] || false;

                  const formatDate = (dateStr) => {
                    const date = new Date(dateStr);
                    return `${date.getDate().toString().padStart(2, "0")}-${(
                      date.getMonth() + 1
                    )
                      .toString()
                      .padStart(2, "0")}-${date.getFullYear()}`;
                  };

                  return (
                    <tr key={offer._id}>
                      <td>{index + 1}</td>
                      <td>{offer.offer_name}</td>
                      <td>{offer.discount_on_rate}</td>
                      <td>{offer.discount_percentage}</td>
                      <td>{offer.discount_percent_fixed}</td>
                      <td>{formatDate(offer.valid_from)}</td>
                      <td>{formatDate(offer.valid_to)}</td>
                      <td>
                        <Button
                          variant={isApplied ? "danger" : "success"}
                          size="sm"
                          onClick={() => handleApply(offer, index)}
                        >
                          {isApplied ? "Unapply" : "Apply"}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <p>No offers available at the moment.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleFestivalCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentDetails;
